var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg031Woman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 464 464",
    height: 512,
    viewBox: "0 0 464 464",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m386 416.74v39.26c0 4.42-3.58 8-8 8h-292c-4.42 0-8-3.58-8-8v-39.26c0-24.46 11.78-46.4 30-60.04v-257.2c0-54.95 44.55-99.5 99.5-99.5h50c54.95 0 99.5 44.55 99.5 99.5v257.97c17.65 13.68 29 35.26 29 59.27z",
    fill: "#c79a83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m331 161.24v40.89c0 54.696-44.348 99-99 99-54.65 0-99-44.302-99-99v-40.9c0-39.76 32.24-72 72-72h54c39.76 0 72 32.24 72 72.01z",
    fill: "#e0b7a3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m357 99.5v258.22c-12.6-9.75-28.41-15.55-45.57-15.55-22.872 0-41.43-18.478-41.43-41.34v-6.83l-.15-.37c35.9-14.86 61.15-50.23 61.15-91.5v-40.89c0-39.771-32.24-72.01-72-72.01h-54c-39.76 0-72 32.24-72 72v40.9c0 41.27 25.25 76.64 61.15 91.5l-.15.37v6.83c0 22.86-18.556 41.34-41.43 41.34-16.71 0-32.13 5.5-44.57 14.78v-257.45c0-54.95 44.55-99.5 99.5-99.5h50c54.95 0 99.5 44.55 99.5 99.5z",
    fill: "#42434d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m386 416.74v39.26c0 4.418-3.582 8-8 8h-292c-4.418 0-8-3.582-8-8v-39.26c0-41.031 33.148-74.952 74.178-74.572 6.013.056 11.75-1.169 16.922-3.418v.01c12.118 27.55 40.904 44.111 70.9 40.59 23.97-2.81 45.03-18.15 54.9-40.59v-.01c5.173 2.249 10.91 3.474 16.922 3.418 41.03-.38 74.178 33.541 74.178 74.572z",
    fill: "#befa91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m236.05 379.69c1.3-.07 2.61-.19 3.91-.34-1.3.16-2.6.27-3.91.34z",
    fill: "#c79a83"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m271.13 310.42c-24.637 10.313-51.712 11.113-78.26 0 1.356-5.626 1.13-9.27 1.13-16.42l.15-.37c24.082 9.996 51.571 10.016 75.7 0l.15.37c0 7.153-.226 10.796 1.13 16.42z",
    fill: "#a07765"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m294.973 7.297c12.188 4.959 8.15 23.053-5.005 22.733-1.76-.043 1.934-.03-52.468-.03-50.53 0-98.458 38.034-99.483 102.691-.021 1.347-.251 2.69-.72 3.953-5.494 14.794-4.297 23.854-4.297 65.486 0 10.238 1.559 20.123 4.442 29.411.359 1.156.558 2.355.558 3.566v99.277c0 5.125-3.252 9.745-8.134 11.306-7.95 2.541-15.318 6.377-21.866 11.26v-257.45c0-54.952 44.548-99.5 99.5-99.5h50c13.258 0 25.908 2.592 37.473 7.297z",
    fill: "#4d4e59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m240.5 37v52.23h-16v-52.23c0-4.42 3.58-8 8-8s8 3.58 8 8z",
    fill: "#2c2c33"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m209.594 266.066c16.275 10.175 3.436 35.148-14.377 27.999-36.631-14.701-62.217-50.395-62.217-91.935 0-43.694-1.178-50.986 4.626-66.344 5.059-13.387 25.374-10.422 25.374 5.444v40.9c0 36.512 19.189 66.801 46.594 83.936z",
    fill: "#f2d1c2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m236.05 379.69c1.3-.07 2.61-.19 3.91-.34-1.3.16-2.6.27-3.91.34z",
    fill: "#c79a83"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m173.247 346.728c5.506 9.073.512 20.907-9.749 23.615-24.507 6.467-56.498 23.706-56.498 71.397v22.26h-21c-4.418 0-8-3.582-8-8v-39.26c0-41.01 33.11-75.01 74.11-74.57 6.04.06 11.8-1.16 16.99-3.42v.01c1.218 2.767 2.605 5.427 4.147 7.968z",
    fill: "#d0ffad"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#99d856"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m290.753 346.728c-5.506 9.073-.512 20.907 9.749 23.615 24.507 6.467 56.498 23.706 56.498 71.397v22.26h21c4.418 0 8-3.582 8-8v-39.26c0-41.01-33.11-75.01-74.11-74.57-6.04.06-11.8-1.16-16.99-3.42v.01c-1.218 2.767-2.605 5.427-4.147 7.968z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 379.35v84.65h-16v-84.65c5.248.616 10.573.637 16 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg031Woman);
export default __webpack_public_path__ + "static/media/031-woman.a2ea071f58eef4cd6b5d1bbae635ada3.svg";
export { ForwardRef as ReactComponent };